/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Pagination from "../../../../../SharedComponent/Pagination";
import {
  FaEdit,
  FaEye,
  FaTrash,
  FaMapMarkerAlt,
  FaWarehouse,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

import style from "./../AssetManagerDashboard.module.css";
import AssetUpdateModal from "../../../../../components/common/AssetUpdateModal";
import {
  deleteProtected,
  getProtected,
} from "../../../../../network/ApiService";
import { API_END_POINTS } from "../../../../../network/apiEndPoint";
import Button from "../../../../../SharedComponent/Button/Button";
import CreateAssetMaintainance from "./CreateAssetMaintainance";
import EditMaintainanceAssetModal from "./EditMaintainanceAssetModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { formatYearOfManufacture } from "../../../../../utils/yearOfManufacture";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { baseURL, baseURlNoAPI } from "../../../../../network/baseUrl";
import Carousel from "../../../../../components/Carousel";
import { getImageAttachments } from "../../../../../utils/attachmentImages";
import defaultImage from "../../../../../assets/photo.png";

function formatToEuropean(number) {
  return Number(number).toLocaleString("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

const AssetManagerTable = (props) => {
  const {
    totalAssets,
    allAssets,
    limit,
    currentPage,
    setCurrentPage,
    setViewAssetId,
    handleDeleteAsset,
  } = props;
  const { t } = useTranslation();
  const [selectedAsset, setSelectedAsset] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedMaintainance, setSelectedMaintainance] = useState(null);
  const navigate = useNavigate();

  const mastTypes = [
    { value: 0, type: t("assetDetails.mastTypes.none") },
    { value: 1, type: t("assetDetails.mastTypes.standard") },
    { value: 2, type: t("assetDetails.mastTypes.mono") },
    { value: 3, type: t("assetDetails.mastTypes.duplex") },
    { value: 5, type: t("assetDetails.mastTypes.triplex") },
    { value: 8, type: t("assetDetails.mastTypes.quattro") },
    { value: 9, type: t("assetDetails.mastTypes.telescopic") },
  ];

  const opticalConditions = [
    { value: "", option: t("common.select") },
    { value: 2, option: t("createAsset.opticalCondition.very_good") },
    { value: 3, option: t("createAsset.opticalCondition.good") },
    { value: 4, option: t("createAsset.opticalCondition.used") },
    { value: 5, option: t("createAsset.opticalCondition.bad") },
    { value: 6, option: t("createAsset.opticalCondition.very_bad") },
    { value: 7, option: t("createAsset.opticalCondition.new") },
  ];

  const statusKeyMap = {
    New: "New",
    Used: "Used",
    Demo: "Demo",
    Rental: "Rental",
    "Short Time Hire": "shortTermHire",
    shortTermHire: "shortTermHire",
    "Short term hire": "shortTermHire",
  };

  const batteryTypes = [
    { value: 2, option: t("assets.options.pzs") },
    { value: 3, option: t("assets.options.gel") },
    { value: 4, option: t("assets.options.lithium-ion") },
    { value: 5, option: t("assets.options.starter") },
    { value: 6, option: t("assets.options.waterless") },
    { value: 7, option: t("assets.options.tppl") },
    { value: 8, option: t("assets.options.nimh") },
    { value: 9, option: t("assets.options.battery_others") },
  ];

  const chargerTypes = [
    { value: 1, option: t("assets.options.single-phase") },
    { value: 2, option: t("assets.options.three-phase") },
    { value: 3, option: t("assets.options.hf") },
    { value: 4, option: t("assets.options.modular") },
    { value: 5, option: t("assets.options.opportunity") },
    { value: 6, option: t("assets.options.li-ferro") },
    { value: 7, option: t("assets.options.scr") },
    { value: 8, option: t("assets.options.charger_others") },
  ];

  const attachmentsTypes = [
    { value: "", option: t("assets.fields.selectClassification") },
    { value: 1, option: t("attachments.types.loadPushUnit") },
    { value: 2, option: t("attachments.types.baleClamps") },
    { value: 3, option: t("attachments.types.baleClamps360") },
    { value: 4, option: t("attachments.types.pulpBaleClamps360") },
    { value: 5, option: t("attachments.types.boxDischargeUnit") },
    {
      value: 6,
      option: t("attachments.types.multiPalletHandlerProfile"),
    },
    { value: 7, option: t("attachments.types.poleTineClamps") },
    { value: 8, option: t("attachments.types.twoWayForkClamps") },
    { value: 9, option: t("attachments.types.twoWayForkClamps360") },
    { value: 10, option: t("attachments.types.rotators360") },
    { value: 11, option: t("attachments.types.rotators360BoltOn") },
    { value: 12, option: t("attachments.types.dischargeUnit") },
    { value: 13, option: t("attachments.types.rotatingJawClamps") },
    { value: 14, option: t("attachments.types.drumClamps") },
    { value: 15, option: t("attachments.types.drumClamps360") },
    { value: 16, option: t("attachments.types.harbourClamps") },
    {
      value: 17,
      option: t("attachments.types.applianceClampsCirculating"),
    },
    {
      value: 18,
      option: t("attachments.types.applianceClampsRigid"),
    },
    { value: 19, option: t("attachments.types.forkClamps") },
    { value: 20, option: t("attachments.types.forkClamps360") },
    { value: 21, option: t("attachments.types.loadPushPulls") },
    { value: 22, option: t("attachments.types.jibCrane") },
    { value: 23, option: t("attachments.types.loadStabilizers") },
    {
      value: 24,
      option: t("attachments.types.multiPalletHandlers21"),
    },
    {
      value: 25,
      option: t("attachments.types.palletHandlersLoadExtender"),
    },
    {
      value: 26,
      option: t("attachments.types.multiPalletHandlerProfile"),
    },
    {
      value: 27,
      option: t("attachments.types.multiPalletHandlers321"),
    },
    {
      value: 28,
      option: t("attachments.types.multiPalletHandlers4"),
    },
    {
      value: 29,
      option: t("attachments.types.multiPalletHandlers42"),
    },
    {
      value: 30,
      option: t("attachments.types.multiPalletHandlers64"),
    },
    { value: 31, option: t("attachments.types.palletInverters360") },
    { value: 32, option: t("attachments.types.loadExtenders") },
    { value: 33, option: t("attachments.types.paperRollClamps360") },
    { value: 34, option: t("attachments.types.paperRollClamps180") },
    {
      value: 35,
      option: t("attachments.types.paperRollClamps360Arm"),
    },
    {
      value: 36,
      option: t("attachments.types.paperRollClamps180Arm"),
    },
    { value: 37, option: t("attachments.types.rollUpender90") },
    {
      value: 38,
      option: t("attachments.types.rollUpender90With360"),
    },
    { value: 39, option: t("attachments.types.tyreClamps360") },
    { value: 40, option: t("attachments.types.foamClamps") },
    {
      value: 41,
      option: t("attachments.types.hoseReelsSupportFlex"),
    },
    { value: 42, option: t("attachments.types.hydraulicScoops") },
    { value: 43, option: t("attachments.types.sideshifts") },
    { value: 44, option: t("attachments.types.sideshiftsDual") },
    { value: 45, option: t("attachments.types.sideshiftsTriple") },
    {
      value: 46,
      option: t("attachments.types.trilateralHeadsShaft"),
    },
    { value: 47, option: t("attachments.types.trilateralHeadsRack") },
    { value: 48, option: t("attachments.types.brickBlockClamps") },
    { value: 49, option: t("attachments.types.tobaccoClamps") },
    { value: 50, option: t("attachments.types.tissueRollClamps360") },
    { value: 51, option: t("attachments.types.carpetBoom") },
    { value: 52, option: t("attachments.types.loadExtenders") },
    { value: 53, option: t("attachments.types.pulpBaleClampsRigid") },
    {
      value: 54,
      option: t("attachments.types.pulpBaleClampsArticulating"),
    },
    { value: 55, option: t("attachments.types.forkPositioners360") },
    {
      value: 56,
      option: t("attachments.types.forkPositionersProfile"),
    },
    {
      value: 57,
      option: t("attachments.types.forkPositionersShaft"),
    },
    { value: 58, option: t("attachments.types.other") },
    { value: 59, option: t("attachments.types.snowPusher") },
    { value: 60, option: t("attachments.types.roundTimberGripper") },
    { value: 61, option: t("attachments.types.forkPositioners") },
    {
      value: 62,
      option: t("attachments.types.tineAdjustmentSideshift"),
    },
    { value: 63, option: t("attachments.types.pushOutForks") },
    { value: 64, option: t("attachments.types.baleTongsSideshift") },
    { value: 65, option: t("attachments.types.reelClampSwivelling") },
    {
      value: 66,
      option: t("attachments.types.tiltingDeviceShovels"),
    },
    {
      value: 67,
      option: t("attachments.types.doubleReelTurningClamping"),
    },
    { value: 68, option: t("attachments.types.attachmentClamp") },
    { value: 69, option: t("attachments.types.hydraulicRopeHoist") },
    { value: 70, option: t("attachments.types.telescopeForkTine") },
    { value: 71, option: t("attachments.types.accessories") },
    { value: 72, option: t("attachments.types.forks") },
    { value: 73, option: t("attachments.types.barrelLifter") },
    { value: 74, option: t("attachments.types.loadGuardGrill") },
    { value: 75, option: t("attachments.types.personsBasket") },
    { value: 76, option: t("attachments.types.telescopicCrane") },
    { value: 77, option: t("attachments.types.forkExtension") },
    { value: 78, option: t("attachments.types.pouchLifter") },
    { value: 79, option: t("attachments.types.sweepingMachine") },
    { value: 80, option: t("attachments.types.pipeClamp") },
    { value: 81, option: t("attachments.types.clampCementPipes") },
    { value: 82, option: t("attachments.types.containerSpreader") },
    { value: 83, option: t("attachments.types.piggybackSpreader") },
    { value: 84, option: t("attachments.types.liftTruckScales") },
  ];

  const liftMast = [
    { value: 0, option: t("assets.fields.selectClassification") },
    { value: 1, option: t("assetDetails.mastTypes.standard") },
    { value: 2, option: t("assetDetails.mastTypes.mono") },
    { value: 3, option: t("assetDetails.mastTypes.duplex") },
    { value: 5, option: t("assetDetails.mastTypes.triplex") },
    { value: 8, option: t("assetDetails.mastTypes.quattro") },
    { value: 9, option: t("assetDetails.mastTypes.telescopic") },
  ];

  const workPlatformTypes = [
    { value: 1, option: t("workPlatform.classificationTypes.other") },
    { value: 2, option: t("workPlatform.classificationTypes.trailed") },
    { value: 3, option: t("workPlatform.classificationTypes.telescope") },
    { value: 4, option: t("workPlatform.classificationTypes.vertical") },
    { value: 5, option: t("workPlatform.classificationTypes.articulated") },
    { value: 6, option: t("workPlatform.classificationTypes.scissors") },
    { value: 7, option: t("workPlatform.classificationTypes.truckMounted") },
    { value: 8, option: t("workPlatform.classificationTypes.special") },
    { value: 9, option: t("workPlatform.classificationTypes.spider") },
  ];

  const cleaningEquipments = [
    {
      value: "",
      option: t("cleaningEquipment.classificationTypes.select"),
    },
    {
      value: 1,
      option: t("cleaningEquipment.classificationTypes.other"),
    },
    {
      value: 2,
      option: t("cleaningEquipment.classificationTypes.pedestrianSweeper"),
    },
    {
      value: 3,
      option: t(
        "cleaningEquipment.classificationTypes.pedestrianVacuumSweeper"
      ),
    },
    {
      value: 4,
      option: t(
        "cleaningEquipment.classificationTypes.pedestrianScrubberDryer"
      ),
    },
    {
      value: 5,
      option: t("cleaningEquipment.classificationTypes.streetCleaningMachine"),
    },
    {
      value: 6,
      option: t("cleaningEquipment.classificationTypes.pressureWasher"),
    },
    {
      value: 7,
      option: t(
        "cleaningEquipment.classificationTypes.pedestrianScrubberDryer2"
      ),
    },
    {
      value: 8,
      option: t("cleaningEquipment.classificationTypes.rideOnScrubberDryer"),
    },
    {
      value: 9,
      option: t("cleaningEquipment.classificationTypes.rideOnSweeper"),
    },
    {
      value: 10,
      option: t("cleaningEquipment.classificationTypes.rideOnVacuumSweeper"),
    },
    {
      value: 11,
      option: t("cleaningEquipment.classificationTypes.steamMachine"),
    },
    {
      value: 12,
      option: t("cleaningEquipment.classificationTypes.vacuumCleaner"),
    },
    {
      value: 13,
      option: t("cleaningEquipment.classificationTypes.escalatorCleaner"),
    },
    {
      value: 14,
      option: t("cleaningEquipment.classificationTypes.singleDiscMachine"),
    },
    {
      value: 15,
      option: t("cleaningEquipment.classificationTypes.carpetCleaner"),
    },
    {
      value: 16,
      option: t("cleaningEquipment.classificationTypes.ridingScrubberDryer"),
    },
  ];

  const spareParts = [
    { value: "", option: t("spareParts.classificationTypes.select") },
    {
      value: "batteryindicator",
      option: t("spareParts.classificationTypes.batteryindicator"),
    },
    {
      value: "board",
      option: t("spareParts.classificationTypes.board"),
    },
    {
      value: "cable",
      option: t("spareParts.classificationTypes.cable"),
    },
    { value: "cap", option: t("spareParts.classificationTypes.cap") },
    {
      value: "chassispart",
      option: t("spareParts.classificationTypes.chassispart"),
    },
    {
      value: "control",
      option: t("spareParts.classificationTypes.control"),
    },
    {
      value: "cover",
      option: t("spareParts.classificationTypes.cover"),
    },
    {
      value: "cylinder",
      option: t("spareParts.classificationTypes.cylinder"),
    },
    {
      value: "driveengine",
      option: t("spareParts.classificationTypes.driveengine"),
    },
    {
      value: "drivetrain",
      option: t("spareParts.classificationTypes.drivetrain"),
    },
    {
      value: "harness",
      option: t("spareParts.classificationTypes.harness"),
    },
    {
      value: "hydraulics",
      option: t("spareParts.classificationTypes.hydraulics"),
    },
    {
      value: "magneticbrake",
      option: t("spareParts.classificationTypes.magneticbrake"),
    },
    {
      value: "motorcontrol",
      option: t("spareParts.classificationTypes.motorcontrol"),
    },
    {
      value: "others",
      option: t("spareParts.classificationTypes.others"),
    },
    {
      value: "powertrain",
      option: t("spareParts.classificationTypes.powertrain"),
    },
    {
      value: "pumpengine",
      option: t("spareParts.classificationTypes.pumpengine"),
    },
    {
      value: "relay",
      option: t("spareParts.classificationTypes.relay"),
    },
    {
      value: "seat",
      option: t("spareParts.classificationTypes.seat"),
    },
    {
      value: "steeringcolumn",
      option: t("spareParts.classificationTypes.steeringcolumn"),
    },
    {
      value: "steeringmotor",
      option: t("spareParts.classificationTypes.steeringmotor"),
    },
    {
      value: "supportwheel",
      option: t("spareParts.classificationTypes.supportwheel"),
    },
    {
      value: "tube",
      option: t("spareParts.classificationTypes.tube"),
    },
    {
      value: "tyres",
      option: t("spareParts.classificationTypes.tyres"),
    },
    {
      value: "valveblock",
      option: t("spareParts.classificationTypes.valveblock"),
    },
  ];

  const constrcutionMachinery = [
    {
      value: "",
      option: t("constructionMachinery.classificationTypes.select"),
    },
    {
      value: 2,
      option: t(
        "constructionMachinery.classificationTypes.hydraulicExcavators"
      ),
    },
    {
      value: 3,
      option: t("constructionMachinery.classificationTypes.wheelExcavator"),
    },
    {
      value: 4,
      option: t("constructionMachinery.classificationTypes.miniExcavator"),
    },
    {
      value: 5,
      option: t(
        "constructionMachinery.classificationTypes.demolitionExcavator"
      ),
    },
    {
      value: 6,
      option: t(
        "constructionMachinery.classificationTypes.rehandlingExcavator"
      ),
    },
    {
      value: 7,
      option: t("constructionMachinery.classificationTypes.draglineExcavator"),
    },
    {
      value: 8,
      option: t("constructionMachinery.classificationTypes.roadRailExcavator"),
    },
    {
      value: 10,
      option: t("constructionMachinery.classificationTypes.wheelLoader"),
    },
    {
      value: 11,
      option: t("constructionMachinery.classificationTypes.compactLoader"),
    },
    {
      value: 12,
      option: t(
        "constructionMachinery.classificationTypes.materialHandlingLoader"
      ),
    },
    {
      value: 14,
      option: t("constructionMachinery.classificationTypes.rigidBackhoeLoader"),
    },
    {
      value: 15,
      option: t(
        "constructionMachinery.classificationTypes.articulatedBackhoeLoader"
      ),
    },
    {
      value: 16,
      option: t("constructionMachinery.classificationTypes.miniBackhoeLoader"),
    },
    {
      value: 18,
      option: t("constructionMachinery.classificationTypes.bulldozer"),
    },
    {
      value: 19,
      option: t("constructionMachinery.classificationTypes.crawlerLoader"),
    },
    {
      value: 20,
      option: t(
        "constructionMachinery.classificationTypes.pipelayingCaterpillar"
      ),
    },
    {
      value: 21,
      option: t("constructionMachinery.classificationTypes.weldBead"),
    },
    {
      value: 23,
      option: t("constructionMachinery.classificationTypes.grader"),
    },
    {
      value: 24,
      option: t("constructionMachinery.classificationTypes.selfPoweredScraper"),
    },
    {
      value: 25,
      option: t("constructionMachinery.classificationTypes.trailedScraper"),
    },
    {
      value: 26,
      option: t("constructionMachinery.classificationTypes.scrapedozer"),
    },
    {
      value: 28,
      option: t(
        "constructionMachinery.classificationTypes.articulatedDumpTruck"
      ),
    },
    {
      value: 29,
      option: t("constructionMachinery.classificationTypes.rigidDumpTruck"),
    },
    {
      value: 30,
      option: t("constructionMachinery.classificationTypes.miniDumper"),
    },
    {
      value: 31,
      option: t("constructionMachinery.classificationTypes.trackedDumper"),
    },
    {
      value: 33,
      option: t("constructionMachinery.classificationTypes.mobileCrane"),
    },
    {
      value: 34,
      option: t("constructionMachinery.classificationTypes.truckCrane"),
    },
    {
      value: 35,
      option: t("constructionMachinery.classificationTypes.crawlerCrane"),
    },
    {
      value: 36,
      option: t("constructionMachinery.classificationTypes.towerCrane"),
    },
    {
      value: 37,
      option: t("constructionMachinery.classificationTypes.selfErectingCrane"),
    },
    {
      value: 38,
      option: t(
        "constructionMachinery.classificationTypes.mobileConstructionCrane"
      ),
    },
    {
      value: 39,
      option: t("constructionMachinery.classificationTypes.docksideCrane"),
    },
    {
      value: 40,
      option: t("constructionMachinery.classificationTypes.miniCrane"),
    },
    {
      value: 41,
      option: t("constructionMachinery.classificationTypes.auxiliaryCrane"),
    },
    {
      value: 43,
      option: t(
        "constructionMachinery.classificationTypes.singleDrumCompactor"
      ),
    },
    {
      value: 44,
      option: t(
        "constructionMachinery.classificationTypes.asphaltCompactorTandem"
      ),
    },
    {
      value: 45,
      option: t("constructionMachinery.classificationTypes.combiRoller"),
    },
    {
      value: 46,
      option: t("constructionMachinery.classificationTypes.pneumaticCompactor"),
    },
    {
      value: 47,
      option: t("constructionMachinery.classificationTypes.sheepsfootRoller"),
    },
    {
      value: 48,
      option: t("constructionMachinery.classificationTypes.landfillCompactor"),
    },
    {
      value: 49,
      option: t("constructionMachinery.classificationTypes.towedRoller"),
    },
    {
      value: 51,
      option: t("constructionMachinery.classificationTypes.truckMixer"),
    },
    {
      value: 52,
      option: t(
        "constructionMachinery.classificationTypes.concreteScrewConveyor"
      ),
    },
    {
      value: 53,
      option: t("constructionMachinery.classificationTypes.truckConcretePump"),
    },
    {
      value: 54,
      option: t("constructionMachinery.classificationTypes.concretePump"),
    },
    {
      value: 56,
      option: t("constructionMachinery.classificationTypes.wheeledPaver"),
    },
    {
      value: 57,
      option: t("constructionMachinery.classificationTypes.trackedPaver"),
    },
    {
      value: 58,
      option: t("constructionMachinery.classificationTypes.asphaltPlaner"),
    },
    {
      value: 59,
      option: t("constructionMachinery.classificationTypes.surfaceMiner"),
    },
    {
      value: 60,
      option: t("constructionMachinery.classificationTypes.asphaltRecycler"),
    },
    {
      value: 61,
      option: t("constructionMachinery.classificationTypes.soilStabilizer"),
    },
    {
      value: 62,
      option: t("constructionMachinery.classificationTypes.coldRecycler"),
    },
    {
      value: 63,
      option: t("constructionMachinery.classificationTypes.hotRecycler"),
    },
    {
      value: 64,
      option: t("constructionMachinery.classificationTypes.slipformPaver"),
    },
    {
      value: 65,
      option: t("constructionMachinery.classificationTypes.gritter"),
    },
    {
      value: 67,
      option: t("constructionMachinery.classificationTypes.drillingMachine"),
    },
    {
      value: 68,
      option: t("constructionMachinery.classificationTypes.anchorDrillRig"),
    },
    {
      value: 69,
      option: t("constructionMachinery.classificationTypes.drillRig"),
    },
    {
      value: 70,
      option: t("constructionMachinery.classificationTypes.blastholeDrill"),
    },
    {
      value: 71,
      option: t("constructionMachinery.classificationTypes.trenchCutter"),
    },
    {
      value: 72,
      option: t("constructionMachinery.classificationTypes.diphragmGrabWall"),
    },
    {
      value: 73,
      option: t("constructionMachinery.classificationTypes.depthVibrator"),
    },
    {
      value: 74,
      option: t("constructionMachinery.classificationTypes.chainTrencher"),
    },
    {
      value: 76,
      option: t(
        "constructionMachinery.classificationTypes.universalPillingRig"
      ),
    },
    {
      value: 77,
      option: t("constructionMachinery.classificationTypes.pilingHammer"),
    },
    {
      value: 79,
      option: t("constructionMachinery.classificationTypes.drilling"),
    },
    {
      value: 80,
      option: t("constructionMachinery.classificationTypes.tunnelDumper"),
    },
    {
      value: 81,
      option: t("constructionMachinery.classificationTypes.tunnelLoader"),
    },
    {
      value: 82,
      option: t("constructionMachinery.classificationTypes.tunnelExcavator"),
    },
    {
      value: 83,
      option: t("constructionMachinery.classificationTypes.sprayConcretePump"),
    },
    {
      value: 84,
      option: t("constructionMachinery.classificationTypes.tunnelTruckMixer"),
    },
    {
      value: 85,
      option: t("constructionMachinery.classificationTypes.tunnelingShield"),
    },
    {
      value: 86,
      option: t("constructionMachinery.classificationTypes.roadheader"),
    },
    {
      value: 88,
      option: t("constructionMachinery.classificationTypes.miningExcavator"),
    },
    {
      value: 89,
      option: t("constructionMachinery.classificationTypes.miningDumper"),
    },
    {
      value: 91,
      option: t("constructionMachinery.classificationTypes.others"),
    },
    {
      value: 93,
      option: t("constructionMachinery.classificationTypes.attachments"),
    },
    {
      value: 94,
      option: t("constructionMachinery.classificationTypes.powerGenerator"),
    },
    {
      value: 95,
      option: t("constructionMachinery.classificationTypes.pileDriving"),
    },
    {
      value: 96,
      option: t("constructionMachinery.classificationTypes.compressor"),
    },
    {
      value: 98,
      option: t("constructionMachinery.classificationTypes.trailer"),
    },
    {
      value: 100,
      option: t("constructionMachinery.classificationTypes.truck"),
    },
    {
      value: 101,
      option: t("constructionMachinery.classificationTypes.plateCompactor"),
    },
    {
      value: 102,
      option: t("constructionMachinery.classificationTypes.ramps"),
    },
  ];

  const getConstrcutionType = (value) => {
    const type = constrcutionMachinery.find((wpt) => wpt?.value === value);
    return type?.option || "N/A";
  };

  const getSparePartType = (value) => {
    const type = spareParts.find((wpt) => wpt?.value === value);
    return type?.option || "N/A";
  };

  const getCleaningType = (value) => {
    const type = cleaningEquipments.find((wpt) => wpt?.value === value);
    return type?.option || "N/A";
  };

  const getWorkPlatformType = (value) => {
    const type = workPlatformTypes.find((wpt) => wpt?.value === value);
    return type?.option || "N/A";
  };
  const getBatteryType = (value) => {
    const type = batteryTypes.find((bt) => bt?.value === value);
    return type?.option || "N/A";
  };
  const getChargerType = (value) => {
    const type = chargerTypes.find((bt) => bt?.value === value);
    return type?.option || "N/A";
  };
  const getAttachmentsType = (value) => {
    const type = attachmentsTypes.find((bt) => bt?.value === value);
    return type?.option || "N/A";
  };
  const getLiftMastType = (value) => {
    const type = liftMast.find((bt) => bt?.value === value);
    return type?.option || "N/A";
  };

  function getStatusTranslation(status) {
    const key = statusKeyMap[status] || status;
    return t(`assets.status.${key}`) || status;
  }

  const getMastType = (value) => {
    const type = mastTypes.find((mt) => mt?.value === value);
    // console.log("type = " , type);
    return type?.type;
  };

  const getOpticalCondition = (value) => {
    const condition = opticalConditions.find((oc) => oc.value === value);
    // console.log("type = " , type);
    return condition ? condition.option : "N/A";
  };

  return (
    <div className="mx-auto">
      <div className="flex flex-col space-y-4 sm:space-y-6">
        {allAssets?.map((asset, index) => (
          <div
            className="bg-white -xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden w-full"
            key={index}
          >
            <div className="flex flex-col lg:flex-row">
              {/* Asset Image Section */}
              <div className="relative lg:w-1/3 xl:w-1/4 flex-shrink-0">
                {/* <span
                  className={`absolute top-3 left-3 px-3 py-1 text-xs font-semibold -full z-10 ${
                    asset.status === "Miete"
                      ? "bg-blue-600 text-white"
                      : asset.status === "Used"
                      ? "bg-amber-500 text-white"
                      : "bg-green-600 text-white"
                  }`}
                >
                  {asset?.status}
                </span> */}
                <div className="relative h-48 sm:h-56 w-full">
                  <Carousel
                    key={asset.id}
                    attachments={getImageAttachments(asset)}
                    fallbackSrc={defaultImage}
                  />
                </div>
              </div>

              {/* Asset Details Section */}
              <div className="flex-1 p-3 sm:p-4 lg:p-4">
                {/* Header: ID and Status Tags */}
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3"></div>

                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-3">
                  <div className="flex flex-wrap items-center gap-2">
                    {asset?.status && (
                      <span
                        className={`px-2 py-1 text-xs rounded-full font-medium border rounded-full bg-green-600 border-green-600 text-white`}
                      >
                        {getStatusTranslation(asset.status)}
                      </span>
                    )}
                    {asset?.asset_type === "Batteries" &&
                      asset?.battery_type && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border`}
                        >
                          {getBatteryType(asset?.battery_type)}
                        </span>
                      )}

                    {asset?.asset_type === "Chargers" &&
                      asset?.chargerLoadertype && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border `}
                        >
                          {getChargerType(asset?.chargerLoadertype)}
                        </span>
                      )}

                    {asset?.asset_type === "Attachments" &&
                      asset?.attachment_toc && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border`}
                        >
                          {getAttachmentsType(asset?.attachment_toc)}
                        </span>
                      )}

                    {asset?.asset_type === "Cleaning Equipment" &&
                      asset?.cleaning_toc && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border`}
                        >
                          {getCleaningType(asset?.cleaning_toc)}
                        </span>
                      )}
                    {asset?.asset_type === "Spare Parts" &&
                      asset?.sparetype && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border`}
                        >
                          {getSparePartType(asset?.sparetype)}
                        </span>
                      )}
                    {asset?.asset_type === "Construction Machinery" &&
                      asset?.construction_classification && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border`}
                        >
                          {getConstrcutionType(
                            asset?.construction_classification
                          )}
                        </span>
                      )}

                    {(asset?.asset_type === "Lift Mast" ||
                      asset?.asset_type === "Lift Masts") &&
                      asset?.mast_type !== null &&
                      asset?.mast_type !== undefined && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border`}
                        >
                          {getLiftMastType(asset?.mast_type)}
                        </span>
                      )}
                    {(asset?.asset_type === "Work Platform" ||
                      asset?.asset_type === "WorkPlatform" ||
                      asset?.asset_type === "Work Platforms" ||
                      asset?.asset_type === "WorkPlatforms") &&
                      asset?.workplatform_toc && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border`}
                        >
                          {getWorkPlatformType(asset?.workplatform_toc)}
                        </span>
                      )}

                    {/* Show classification for other assets (forklifts, etc.) */}
                    {asset?.asset_type !== "Batteries" &&
                      asset?.asset_type !== "Chargers" &&
                      asset?.asset_type !== "Attachments" &&
                      asset?.asset_type !== "Lift Mast" &&
                      asset?.asset_type !== "Lift Masts" &&
                      asset?.asset_type !== "Work Platform" &&
                      asset?.asset_type !== "WorkPlatform" &&
                      asset?.asset_type !== "Work Platforms" &&
                      asset?.asset_type !== "WorkPlatforms" && 
                      asset?.asset_type !== "Cleaning Equipment" &&
                      asset?.asset_type !== "Spare Parts" &&
                      asset?.asset_type !== "Construction Machinery" &&
                      asset?.classification && (
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium border`}
                        >
                          {t(`classification.${asset.classification}`) ||
                            asset.classification}
                        </span>
                      )}

                    {asset?.optical_condition && (
                      <span
                        className={`px-2 py-1 rounded-full  text-xs font-medium border`}
                      >
                        {getOpticalCondition(asset?.optical_condition) || "N/A"}
                      </span>
                    )}
                  </div>

                  <div className="flex flex-col items-start sm:items-end">
                    {asset?.end_user_price ? (
                      <div className="text-lg font-bold text-blue-600">
                        {formatToEuropean(asset.end_user_price)} €
                      </div>
                    ) : (
                      <span className="text-lg font-bold text-blue-600">
                        {t("assetManagerDashboardList.onRequest")}
                      </span>
                    )}

                    {asset?.book_value && (
                      <div className="text-sm font-bold text-blue-600">
                        ( BV : {formatToEuropean(asset?.book_value)} €)
                      </div>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-3 text-sm">
                  <div className="flex flex-wrap">
                    <div
                      className="font-extrabold text-lg sm:text-xl text-gray-900"
                      title={asset?.manufacturer || "N/A"}
                    >
                      {asset?.manufacturer?.length > 25
                        ? asset?.manufacturer?.slice(0, 25) + "..."
                        : asset?.manufacturer || "N/A"}
                    </div>

                    {asset?.type && (
                      <div
                        className="font-extrabold text-lg sm:text-xl text-gray-900"
                        title={asset?.type || "Type"}
                      >
                        {","}{" "}
                        {asset?.type?.length > 25
                          ? asset?.type?.slice(0, 25) + "..."
                          : asset?.type}
                      </div>
                    )}
                  </div>

                  {/* Asset Details - Stacked on mobile, inline on larger screens */}
                  <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-1 sm:gap-2">
                    {formatYearOfManufacture(asset?.year_of_manufacture) && (
                      <div className="flex items-center">
                        <span className="text-gray-600">
                          {t("assetDetails.fields.year_of_manufacture")}:{" "}
                        </span>
                        <span className="font-medium text-gray-900 ml-1">
                          {formatYearOfManufacture(asset?.year_of_manufacture)}
                        </span>
                        <span className="hidden sm:inline">{" , "}</span>
                      </div>
                    )}
                    {asset?.capacity !== 0 && (
                      <div className="flex items-center">
                        <span className="text-gray-600">
                          {t("assetManagerDashboardList.capacity")}:{" "}
                        </span>
                        <span className="font-medium text-gray-900 ml-1">
                          {asset?.capacity ? `${asset.capacity} Kg` : "N/A"}
                        </span>
                        <span className="hidden sm:inline">{" , "}</span>
                      </div>
                    )}

                    {asset?.lift_height_mm !== null && (
                      <div className="flex items-center">
                        <span className="text-gray-600">
                          {" "}
                          {t("assetManagerDashboardList.liftingHeight")}:{" "}
                        </span>
                        <span className="font-medium text-gray-900 ml-1">
                          {asset?.lift_height_mm
                            ? `${formatToEuropean(asset.lift_height_mm)} mm`
                            : "N/A"}
                        </span>
                        <span className="hidden sm:inline">{" , "}</span>
                      </div>
                    )}

                    {asset?.asset_type != "Batteries" && (
                      <div className="flex items-center">
                        <span className="text-gray-600">
                          {" "}
                          {t("assetManagerDashboardList.mast")}:{" "}
                        </span>
                        <span className="font-medium text-gray-900 truncate ml-1">
                          {asset?.mast_type >= 0 || asset?.mast_type <= 9
                            ? getMastType(asset?.mast_type)
                            : "N/A"}
                        </span>
                        <span className="hidden sm:inline">{" , "}</span>
                      </div>
                    )}

                    {asset?.operating_hours && asset?.operating_hours !== 0 && (
                      <div className="flex items-center">
                        <span className="text-gray-600">
                          {t("assetManagerDashboardList.operatingHours")}:{" "}
                        </span>
                        <span className="font-medium text-gray-900 ml-1">
                          {asset?.operating_hours
                            ? `${asset.operating_hours} h`
                            : "N/A"}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Location Information - Better mobile layout */}
                  <div className="grid grid-cols-1 sm:flex  gap-2">
                    <div className="flex items-center">
                      <FaWarehouse className="text-indigo-500 mr-2 flex-shrink-0 w-4 h-4" />
                      <span className="text-gray-600">
                        {t("assetManagerDashboardList.location")}:
                      </span>
                      <span
                        className="font-medium text-gray-900 truncate ml-1"
                        title={
                          asset?.dealer_city || asset?.dealer_country
                            ? `${asset?.dealer_city || ""}${
                                asset?.dealer_city && asset?.dealer_country
                                  ? ", "
                                  : ""
                              }${asset?.dealer_country || ""}`
                            : "N/A"
                        }
                      >
                        {asset?.dealer_city || asset?.dealer_country
                          ? `${asset?.dealer_city || ""}${
                              asset?.dealer_city && asset?.dealer_country
                                ? ", "
                                : ""
                            }${asset?.dealer_country || ""}`
                          : "N/A"}
                      </span>
                    </div>
                    <div className="flex items-center">
                      <FaMapMarkerAlt className="text-gray-400 mr-2 flex-shrink-0 w-4 h-4" />
                      <span className="text-gray-600">
                        {t("assetManagerDashboardList.zip")}:{" "}
                      </span>
                      <span className="font-medium text-gray-900 ml-1">
                        {asset?.dealer_zip || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="pt-3 mt-3 border-t border-gray-100 flex items-center justify-end">
                  <div className="flex items-center gap-2">
                    <button
                      className="p-2 bg-blue-500 text-white -lg hover:bg-blue-600 transition flex items-center justify-center"
                      onClick={() => {
                        setViewAssetId(asset.id);
                        navigate(`/asset-detail-view/${asset?.id}`);
                      }}
                      title={t("assets.actions.view")}
                    >
                      <FaEye className="text-base" />
                    </button>
                    <button
                      className="p-2 bg-amber-500 text-white -lg hover:bg-amber-600 transition flex items-center justify-center"
                      onClick={() => navigate(`/edit-asset-new/${asset.id}`)}
                      title={t("assets.actions.edit")}
                    >
                      <FaEdit className="text-base" />
                    </button>
                    <button
                      className="p-2 bg-red-500 text-white -lg hover:bg-red-600 transition flex items-center justify-center"
                      onClick={() => handleDeleteAsset(asset)}
                      title={t("assets.actions.delete")}
                    >
                      <FaTrash className="text-base" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {allAssets.length === 0 ? (
        <div className="text-center py-8 sm:py-12">
          <h2 className="text-lg sm:text-xl font-bold text-gray-700">
            No Assets Available
          </h2>
        </div>
      ) : (
        ""
      )}

      <div className="flex justify-center my-4 sm:my-6">
        <Pagination
          totalItems={totalAssets}
          setItemOffset={setCurrentPage}
          itemOffset={currentPage}
          limit={limit}
        />
      </div>

      <AssetUpdateModal
        selectedAsset={selectedAsset}
        setSelectedAsset={setSelectedAsset}
        setShowEditModal={setShowEditModal}
        showEditModal={showEditModal}
      />
    </div>
  );
};

export default AssetManagerTable;

const MaintainanceTable = (props) => {
  const { asset } = props;
  const { t } = useTranslation();
  const [allMaintainance, setAllMaintainance] = useState([]);
  const [selectedMaintainance, setSelectedMaintainance] = useState(null);
  const [loader, setLoader] = useState(false);
  const [createMaintainance, setCreateMaintainance] = useState(null);

  const [upcomingMaintainanceDate, setUpcomingMaintainanceDate] = useState("");
  const navigate = useNavigate();

  const isUpComingDateTomorrow = (record) => {
    const nextMaintenanceDate = new Date(record.date);
    console.log("date = ", nextMaintenanceDate);

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const isTomorrow =
      nextMaintenanceDate.getDate() === tomorrow.getDate() &&
      nextMaintenanceDate.getMonth() === tomorrow.getMonth() &&
      nextMaintenanceDate.getFullYear() === tomorrow.getFullYear();

    if (isTomorrow) {
      // toast.info(
      //   "Upcoming maintenance is scheduled for tomorrow: " +
      //     record.maintenance_history.next_maintenance.date,
      //   { autoClose: 8000 }
      // );
      return true;
    }
    return false;
  };

  const checkForNextMaintenance = (records) => {
    console.log(records);
    if (records?.upcoming_maintenance_alerts?.length === 0) return;
    console.log("array = ", records?.upcoming_maintenance_alerts);
    const assets = records?.upcoming_maintenance_alerts;

    const filteredUpcomingMaintainanceAsset = assets?.filter((asset) =>
      isUpComingDateTomorrow(asset)
    );
    console.log("filtered array = ", filteredUpcomingMaintainanceAsset);
    setUpcomingMaintainanceDate(filteredUpcomingMaintainanceAsset[0]?.date);
    if (filteredUpcomingMaintainanceAsset[0]?.date) {
      toast.info(
        `${filteredUpcomingMaintainanceAsset?.length} upcoming maintainance for tomorrow `,
        { autoClose: 30000 }
      );
    }
  };
  useEffect(() => {
    getAllMaintainance();
  }, []);

  const getAllMaintainance = async () => {
    setAllMaintainance([]);
    try {
      if (!asset?.id) return;
      setLoader(true);
      const url = `${API_END_POINTS.assets}${asset?.id}/maintenance_records/`;
      const response = await getProtected(url);

      if (response) {
        setAllMaintainance(response.results || []);
        console.log("response = ", response);
        checkForNextMaintenance(response);

        // setAssetCount(response.count);
        setLoader(false);
      }
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
      setLoader(false);
    }
  };
  useEffect(() => {
    console.log("upcoming = ", upcomingMaintainanceDate);
  }, [upcomingMaintainanceDate]);

  const handleDeleteAsset = async (id) => {
    if (!window.confirm(t("assets.messages.deleteConfirm"))) return;

    try {
      setLoader(true);
      const url = `${API_END_POINTS.assets}${asset.id}/maintenance/${id}/`;
      const response = await deleteProtected(url);
      if (response) {
        toast.success(t("assets.messages.deleteSuccess"));
        getAllMaintainance();
      }
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
      console.error(e);
      const message = e?.response?.data?.messages;
      if (message?.[0]?.message) {
        toast.error(t("assets.messages.deleteError"));
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <tr>
        <td colSpan={11} style={{ height: "25px" }}>
          {loader ? (
            <div className="modern-loader"></div>
          ) : !allMaintainance?.length ? (
            <>
              {/* {t("maintenance.noData")}{" "} */}
              <Button
                onClick={() => {
                  setCreateMaintainance(asset);
                }}
              >
                {/* {t("maintenance.createNew")} */}
                Schedule Maintainance
              </Button>
              {upcomingMaintainanceDate && (
                <div className="bg-blue-100  my-2 flex items-center justify-center ">
                  <div className="bg-white rounded-lg   max-w-md w-full">
                    <div className="flex items-center mb-2 px-4">
                      <div className="bg-blue-100 p-2 rounded-full ">
                        <svg
                          className="w-6 h-6 text-blue-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                      <h1 className="text-xl font-bold text-gray-800 ml-2">
                        Asset Maintenance Notice
                      </h1>
                    </div>

                    <div className="border-l-4 border-blue-500  ">
                      <p className="font-medium text-gray-700 ml-2">
                        Upcoming maintenance scheduled on{" "}
                        {`${upcomingMaintainanceDate}  `}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <CreateAssetMaintainance
                show={createMaintainance}
                onClose={() => {
                  setCreateMaintainance(false);
                  getAllMaintainance();
                }}
              />
            </>
          ) : (
            <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
              <table style={{ marginLeft: "50px" }}>
                <thead>
                  <tr style={{ minHeight: "200px" }}>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("maintenance.fields.id")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("maintenance.fields.details")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("maintenance.fields.date")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("maintenance.fields.cost")}
                      </div>
                    </th>
                    <th>
                      <div style={{ minWidth: "max-content" }}>
                        {t("common.actions")}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allMaintainance?.map((asset) => (
                    <tr key={asset.id}>
                      <td>{asset.id}</td>
                      <td>{asset.details}</td>
                      <td>{asset.date}</td>
                      <td>{asset.cost}</td>
                      <td>
                        <div className={style["action-buttons"]}>
                          <button
                            className={style["btn-edit"]}
                            onClick={() => {
                              setSelectedMaintainance(asset);
                            }}
                            title={t("common.edit")}
                          >
                            <FaEdit />
                          </button>
                          <button
                            className={style["btn-delete"]}
                            onClick={() => handleDeleteAsset(asset.id)}
                            title={t("common.delete")}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div>
                <Button
                  onClick={() => {
                    setCreateMaintainance(asset);
                  }}
                >
                  {t("maintenance.createNew")}
                </Button>
              </div>
            </div>
          )}
        </td>
      </tr>
      <CreateAssetMaintainance
        show={createMaintainance}
        onClose={() => {
          setCreateMaintainance(false);
        }}
      />
      <EditMaintainanceAssetModal
        show={selectedMaintainance}
        onClose={() => {
          setSelectedMaintainance(null);
          getAllMaintainance();
        }}
        asset={asset}
      />
    </>
  );
};

export { MaintainanceTable };
